import { useEffect, useRef, useState } from 'react'
import DataTable from 'react-data-table-component';
import { ImPrinter } from 'react-icons/im';
import { VscPreview } from 'react-icons/vsc';
import { FaEdit } from 'react-icons/fa';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { selectAuth, selectBranchId, setActiveTab } from '../../redux/features/authSlice';
import { useAssignReturnRiderMutation, useGetDeliveryParcelListQuery } from '../../redux/api/parcelApi/parcelApi';
import CustomLoading from '../../components/CustomLoading';
import CustomModal from '../../components/CustomModal';
import * as Yup from 'yup';
import { useGetRiderListQuery } from '../../redux/api/riderApi/riderApi';
import ReactToPrint from 'react-to-print';
import moment from 'moment';
import Barcode from 'react-barcode';
import { useFormik } from 'formik';
import logo from '../../assets/images/tasnuva_courier.png'
import { IAuthUser } from '../../redux/features/authSlice/authSlice.types';
import { useGetOperatorProfileQuery } from '../../redux/api/profileApi/profileApi';
import jwt_decode from 'jwt-decode';

const statusColor = {
    Pending: "bg-[#FF8C00]/10 text-[#FF8C00]",
    Assigned: "bg-[#9ACD32]/10 text-[#9ACD32]",
    "Set Out": "bg-[#FFCE0D]/10 text-[#FFCE0D]",
    Delivered: "bg-[#3CB043]/10 text-[#3CB043]",
    Returning: "bg-[#1D92D8]/10 text-[#1D92D8]",
    Returned: "bg-[#1D92D8]/10 text-[#1D92D8]",
    Failed: "bg-[#161616]/10 text-[#161616]",
    Restored: "bg-[#001780]/10 text-[#001780]",
    Cancelled: "bg-[#C00000]/10 text-[#C00000]",
    Picked: "bg-[#176A73]/10 text-[#176A73]",
    Stored: "bg-[#9ACD32]/10 text-[#9ACD32]",
};

const ReturnParcelList = () => {
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const [filterText, setFilterText] = useState("");
    const branch_id = useSelector(selectBranchId);
    const { data: deliveryParcel, isLoading: deliveryParceLoading } = useGetDeliveryParcelListQuery(
        branch_id
    );
    const { token } = useSelector(selectAuth);
    const authData: IAuthUser = token ? jwt_decode(token) : null;
    const { data: profileData, isLoading: profileLoading } = useGetOperatorProfileQuery(authData?.id);
    const permissions: string[] = profileData?.permissions ? JSON.parse(profileData?.permissions) : [];
    const [deliveryParcelList, setdeliveryParcelList] = useState([]);
    const [riderAssignModal, setRiderAssignModal] = useState(false);
    const [riderAlreadyAssignModal, setRiderAlreadyAssignModal] = useState(false);
    const [riderInfo, setRiderInfo] = useState(null);
    const { data: riderList, isLoading: riderListLoading } = useGetRiderListQuery(branch_id);
    const [assignReturnRider, pickupRiderAssignResult] = useAssignReturnRiderMutation();
    const [recieptModal, setRecieptModal] = useState(false);
    const ref = useRef();

    const validationSchema = Yup.object().shape({
        rider: Yup.string().required("Rider is required"),
    });

    const initialValues = {
        rider: "",
        inside: "",
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: async (values, { resetForm }) => {
            const data = {
                parcel_id: riderInfo?.id,
                rider_id: values?.rider,
                is_inside_city: values?.inside === 'InSide' ? true : false,
            };
            try {
                await assignReturnRider(data).unwrap();
                toast.success("Rider Assigned Successfully!");
                resetForm();
                setRiderAssignModal(false);
            } catch (error) {
                console.log(error);
                toast.error(error?.data?.message || "Something went wrong!");
            }
        },
    });

    const {
        handleSubmit,
        values,
        touched,
        errors,
        setFieldValue,
        handleBlur,
        resetForm,
    } = formik;

    const handleCancelRider = async () => {
        try {
            toast.info("API is not available!");
        } catch (error) {
            console.log(error);
            toast.error(error?.data?.message || "Something went wrong!");
        }
    }

    const columns = [
        {
            name: "Customer Name",
            selector: (row) => row?.customer_name,
            sortable: true,
        },
        {
            name: "Customer Address",
            selector: (row) => row?.customer_address,
            sortable: true,
        },
        {
            name: "Customer Phone",
            selector: (row) => row?.customer_phone,
            sortable: true,
        },
        {
            name: "Pickup Location",
            selector: (row) => row?.pickup_location,
            sortable: true,
        },
        {
            name: "Collect Amount",
            selector: (row) => "৳ " + row?.collect_amount,
            sortable: true,
        },
        {
            name: "Pickup Status",
            selector: (row) => (
                <div
                    className={`py-1 w-20 text-center rounded ${statusColor[row?.pickup_status]
                        }`}
                >
                    {row?.pickup_status}
                </div>
            ),
            sortable: true,
        },
        {
            name: "Delivery Status",
            selector: (row) => (
                <div
                    className={`py-1 w-20 text-center rounded ${statusColor[row?.delivery_status]
                        }`}
                >
                    {row?.delivery_status}
                </div>
            ),
            sortable: true,
        },
        {
            name: "Assign Rider",
            cell: (row) => (
                <div
                    onClick={() => {
                        if (permissions?.includes("AssignRider") || profileData?.isManager) {
                            setRiderInfo(row);
                            if (row?.delivery_status === 'Restored') {
                                setRiderAssignModal(true);
                            } else if (row?.delivery_status === "Returned") {
                                toast.success("Parcel is already returned!")
                            } else if (row?.delivery_status === 'Returning') {
                                setRiderAlreadyAssignModal(true);
                            }
                        } else {
                            toast.info('You have not permitted!');
                        }
                    }}
                    className={`flex flex-row gap-2 items-center justify-center py-1 w-20 text-center rounded border bg-secondary/10 border-secondary text-secondary cursor-pointer transition-all hover:bg-secondary hover:animate-pulse hover:text-white`}
                >
                    <FaEdit /> Edit
                </div>
            ),
        },
        {
            name: "Print",
            cell: (row) => (
                <div
                    onClick={() => {
                        setRiderInfo(row);
                        setRecieptModal(true);
                    }}
                    className={`flex flex-row gap-2 items-center justify-center py-1 w-24 text-center rounded border bg-secondary/10 border-secondary text-secondary hover:bg-secondary cursor-pointer transition-all  hover:animate-pulse hover:text-white`}
                >
                    <VscPreview /> Preview
                </div>
            ),
        },
    ];

    const filteredParcelList = deliveryParcelList
        ?.filter(
            (item) =>
                item?.customer_name && item?.customer_name.toLowerCase().includes(filterText.toLowerCase())
        )
        ?.reverse();

    useEffect(() => {
        if (deliveryParcel) {
            setdeliveryParcelList(deliveryParcel?.filter(data => data.delivery_status === "Restored" || data.delivery_status === "Returning" || data?.delivery_status === 'Returned'));
        }
    }, [deliveryParcel]);

    useEffect(() => {
        if (pathname === "/return-parcel-list") {
            dispatch(setActiveTab("Return Parcel List"));
        }
    }, [dispatch, pathname]);
    return (
        <div className="w-full flex flex-col gap-10">
            <div className="bg-white shadow-lg rounded-lg p-4 justify-between flex flex-row gap-10">
                <div className="flex flex-col justify-between w-full gap-4">
                    <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
                        <div className="text-2xl font-bold text-text_1">Return Parcel List</div>
                    </div>
                    <div className="flex flex-row gap-4 items-center w-full">
                        <input
                            type="text"
                            className="flex-grow p-2 w-full focus:ring-0 border-2 rounded-lg focus:border-secondary focus:outline-none"
                            placeholder={`Search by customer name`}
                            onChange={(e) => setFilterText(e.target.value)}
                            value={filterText}
                        />
                        <button
                            disabled={!filterText}
                            onClick={() => setFilterText("")}
                            className={`py-2 w-24 text-center border border-warning text-warning rounded bg-warning/10 flex items-center justify-center ${!filterText
                                ? ""
                                : "cursor-pointer transition-all hover:bg-warning hover:animate-pulse hover:text-white"
                                }`}
                        >
                            Clear
                        </button>
                    </div>
                </div>
                <div className="h-40 hidden lg:flex">
                    <img
                        src="https://res.cloudinary.com/di23omfvx/image/upload/v1692428968/self_driving_car_Road_1_npjom3.gif"
                        alt="self drive"
                        className="h-full w-full"
                    />
                </div>
            </div>
            <div className="overflow-x-auto bg-white shadow-lg rounded-lg p-2">
                <DataTable
                    columns={columns}
                    data={filteredParcelList}
                    pagination
                    persistTableHead
                    highlightOnHover
                />
            </div>

            <CustomModal
                showModal={riderAssignModal}
                setShowModal={setRiderAssignModal}
                submitButton={true}
                handleSubmit={handleSubmit}
                title={'Assign Rider'}
                className="md:min-w-[60%] lg:min-w-[40vw] xl:min-w-[29vw]"
            >
                <form
                    onSubmit={handleSubmit}
                    className="w-full flex flex-col gap-2 mt-5 min-w-[70%]"
                >
                    <div className="flex flex-col sm:flex-row gap-5">
                        <div className="w-full">
                            <div className="text-text_2 text-md font-semibold mb-2">
                                SELECT RIDER
                            </div>
                            <select
                                id="rider"
                                onBlur={handleBlur}
                                value={values.rider}
                                onChange={(e) => setFieldValue("rider", e.target.value)}
                                className="w-full border-2 p-2 rounded-lg focus:outline-none focus:border-secondary"
                            >
                                <option value="">Select a rider</option>
                                {riderList?.map((data, index) => {
                                    return (
                                        <option key={index} value={data?.id}>
                                            {data?.name}
                                        </option>
                                    );
                                })}
                            </select>
                            {touched.rider && errors.rider ? (
                                <span className="text-error text-sm mt-1">
                                    {errors.rider}
                                </span>
                            ) : null}
                        </div>
                        <div className="w-full">
                            <div className="text-text_2 text-md font-semibold mb-2">
                                SELECT INSIDE OR OUTSIDE CITY
                            </div>
                            <select
                                id="status"
                                value={values.inside}
                                onChange={(e) => setFieldValue('inside', e.target.value)}
                                className="w-full border-2 p-2 rounded-lg focus:outline-none focus:border-secondary"
                            >
                                <option value="InSide">
                                    Inside City
                                </option>
                                <option value="OutSide">
                                    Outside City
                                </option>
                            </select>
                        </div>
                    </div>
                </form>
            </CustomModal>

            <CustomModal
                showModal={riderAlreadyAssignModal}
                setShowModal={setRiderAlreadyAssignModal}
                handleSubmit={handleCancelRider}
                submitButton={true}
                submitButtonText='Cancel Rider'
                warning={true}
                title={"Rider Information"}
                className="sm:min-w-[70%] md:min-w-[60%] lg:min-w-[25vw] xl:min-w-[20vw]"
            >
                <div
                    className="w-full flex flex-col gap-2 mt-5 min-w-[70%]"
                >
                    <div className="text-text_2">A rider has been assigned to pick up your parcel.</div>
                    <div className="text-text_1 font-semibold text-xl">Contact with rider to get estimated pick up time.</div>
                    <div
                        className="flex flex-row items-center mt-5 gap-4"
                    >
                        <div
                            className="h-28 w-3h-28 rounded-lg overflow-hidden"
                        >
                            <img
                                src={
                                    riderInfo?.deliveryParcel?.rider?.image ||
                                    "https://i.ibb.co/8MgR8kC/images.png"
                                }
                                style={{ height: "100%", objectFit: "cover" }}
                                className="img-fluid"
                                alt=""
                            />
                        </div>
                        <div className="flex flex-col gap-2">
                            <div className="bg-stroke_1 shadow text-text_2 font-semibold text-xl py-2 px-3 rounded">Name: {riderInfo?.deliveryParcel?.rider?.name}</div>
                            <div className="bg-stroke_1 shadow text-text_2 font-semibold text-xl py-2 px-3 rounded">Phone: {riderInfo?.deliveryParcel?.rider?.contact_number}</div>
                        </div>
                    </div>
                </div>
            </CustomModal>

            <CustomModal
                showModal={recieptModal}
                setShowModal={setRecieptModal}
                submitButton={false}
                closeButton={false}
                title={"Rider Information"}
            >
                <div ref={ref} className='p-5 bg-white'>
                    <div className='flex justify-center'>
                        <img src={logo} alt='logo' className='w-52' />
                    </div>
                    <div style={{ width: "100%" }}>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                            }}>
                            <span>Order ID</span>
                            <span>{riderInfo?.order_id} </span>

                        </div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                            }}>
                            <span>Customer Name</span>
                            <span>{riderInfo?.customer_name} </span>

                        </div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                            }}>
                            <span>Customer Phone</span>
                            <span>{riderInfo?.customer_phone} </span>

                        </div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                            }}>
                            <span>Customer District</span>
                            <span>{riderInfo?.customer_district} </span>

                        </div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                            }}>
                            <span>Customer Upazila</span>
                            <span>{riderInfo?.customer_upazila} </span>

                        </div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                            }}>
                            <span>Customer Road</span>
                            <span>{riderInfo?.customer_road} </span>

                        </div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                            }}>
                            <span>Customer Address</span>
                            <span>{riderInfo?.customer_address} </span>

                        </div>

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                            }}>
                            <span>Weight</span>
                            <span>{riderInfo?.weight} kg</span>

                        </div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                            }}>
                            <span>Quantity</span>
                            <span>{riderInfo?.quantity} </span>

                        </div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                            }}>
                            <span>Item Description</span>
                            <span>{riderInfo?.item_description} </span>

                        </div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                            }}>
                            <span>Delivery Instruction</span>
                            <span>{riderInfo?.delivery_instruction} </span>

                        </div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                            }}>
                            <span>Delivery Date</span>
                            <span>{moment(riderInfo?.delivery_date).format('lll')} </span>

                        </div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                            }}>
                            <span>Paid</span>
                            <span>{riderInfo?.isPaid ? "Yes" : "No"} </span>

                        </div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                            }}>
                            <span>Collect Amount</span>
                            <span>{riderInfo?.collect_amount} ৳</span>

                        </div>
                    </div>
                    <hr />
                    <div className="flex justify-center">
                        <Barcode value={riderInfo?.order_id} />
                    </div>
                </div>
                <div className='mt-10 flex w-full justify-end gap-5'>
                    <button
                        onClick={() => setRecieptModal(false)}
                        className={`py-2 w-28 text-center border border-[#606EBF] text-[#606EBF] rounded bg-[#606EBF]/10 flex items-center justify-center cursor-pointer transition-all hover:bg-[#606EBF] hover:animate-pulse hover:text-white`}
                    >
                        Close
                    </button>
                    <ReactToPrint content={() => ref.current} trigger={() => <div
                        className={`flex flex-row gap-2 w-28 items-center justify-center py-1 text-center rounded border bg-secondary/10 border-secondary text-secondary hover:bg-secondary cursor-pointer transition-all  hover:animate-pulse hover:text-white`}
                    >
                        <ImPrinter /> Print
                    </div>} />

                </div>
            </CustomModal>

            {(deliveryParceLoading || riderListLoading || pickupRiderAssignResult.isLoading || profileLoading) && <CustomLoading />}
        </div>
    )
}

export default ReturnParcelList